.advancedSearchModal {
  font-weight: 400;
}

.resultTable {
  padding-top: 1rem;
}

.resultTableHelpText {
  color: var(--cont-color-common-fg-generic-subtle);
  display: block;
  font-size: 14px;
  line-height: 1.5715;
  padding-top: 0.5rem;
}

.selectedRowsTicker {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}
